import React, { useState, useEffect } from "react";
import "./ManageExpertise.scss";
import PlusIcon from "../../assets/icons/PlusIcon";
import PopInWindow from "../popInWindow/PopInWindow";
import CreateExpertise from "./CreateExpertise";
import masterApi from "../../services/masterApi";
import ManageCard from "./ManageCard";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ConfirmationModal from "../../components/confirmationModal/ConfirmationModal";
import Loader from "../../components/loader/Loader";

const ManageExpertise = () => {
  const [ShowPopin, setShowPopin] = useState(false);
  const [expertiseList, setItems] = useState([]);
  const [editingRow, setEditingRow] = useState(null);
  const [reset, setReset] = useState(false);
  const EXPERTISE_DELETE_SUCCESS_MESSAGE = process.env.REACT_APP_EXPERTISE_DELETE_SUCCESS_MESSAGE
  const [isModalVisible, setIsModalVisible] = useState(false); // Modal visibility
  const [loading, setLoading] = useState(true);
  const openPopin = () => {
    setShowPopin(!ShowPopin);
    if (ShowPopin === true) {
     setEditingRow(null);
    }
  };

  useEffect(() => {    
    fetchData(); 
    setLoading(false);
  },[]);

  const handleReset = () => {
    setReset((prev) => !prev);
    fetchData();
  };

  const fetchData = async () => {
    try {
      const response = await masterApi.getAllExpertise()
      let expertiseList=response?.data?.expertiseList;
      setItems(expertiseList)
    } catch(error) {

    } finally {

    }
  };

  const handleEditClick = (row) => {

    openPopin();
    setEditingRow(row);
  };

const handleDeleteClick = async(row) => {
  setEditingRow(row);
  setShowPopin(false);
  setIsModalVisible(true); 
  //setEditingRow(null); 
};
const handleDeleteConfirmClick = async() => {
  setLoading(true);
  const expertiseId = editingRow._id;
const response = await masterApi.deleteExpertise({ expertiseId });
    if (response?.ok) {//sucessfully added user     
      setLoading(false);
      toast.success(EXPERTISE_DELETE_SUCCESS_MESSAGE, {autoClose: 1000, // 1 seconds
      });  
      setShowPopin(ShowPopin)
      fetchData();      
      setIsModalVisible(false);
      setEditingRow(null);
    } else {
      setLoading(false); 
      toast.error(response.response?.data?.message, {
        autoClose: 2000, // 1 seconds
      });      
    }   
};
const closeModal = () => {
  setIsModalVisible(false);
  setEditingRow(null);
};

  return (
    <>
    {loading ? (
        <Loader />
      ) : (
    <div className="manage-roles">
      <div className="tittle-aria">
        <h3>Manage Expertise</h3>
        <button className="btn" onClick={openPopin}>
          <PlusIcon />
        </button>
      </div>
      <div className="roles-list">
        <div className="row">
          <div className="col-md-4">
           {
              expertiseList.map((item) => (

                <ManageCard label={item.expertiseName} status={item.recordStatus} oneditclick={() => handleEditClick(item) } ondeleteclick={() => handleDeleteClick(item) } />
              ))
            }
          </div>
        </div>
      </div>
      {ShowPopin && (
        <PopInWindow title={"Expertise"} closePopin={openPopin}>
          <CreateExpertise  closePopin={openPopin} existingData={editingRow} onSaveReload={handleReset}/>
        </PopInWindow>
      )}

      {isModalVisible && (
        <ConfirmationModal
          show={isModalVisible}
          title="Delete Expertise"
          message={`Are you sure you want to delete ?`}
          onConfirm={handleDeleteConfirmClick} // Call to confirm deletion
          onCancel={closeModal} // Close modal if canceled
          confirmText="Yes, Delete"
          cancelText="No, Cancel"
        />
      )}
    </div>
     )}
    </>
  );
};

export default ManageExpertise;
